import { axios, addHeader } from '@/api/index.js'
const customGroup = {
  get: (id, accessToken) => {
    return axios.get('/customgroup/get?id=' + id, addHeader(accessToken))
  },
  getAll: accessToken => {
    return axios.get('/customgroup/getAll', addHeader(accessToken))
  },
  save: (payload, accessToken) => {
    // const payload = {
    //   name,
    //   description,
    //   nmis,
    // }
    return axios.post('/customgroup/save', payload, addHeader(accessToken))
  },
  delete: (id, accessToken) => {
    return axios.get('/customgroup/delete?id=' + id, addHeader(accessToken))
  },
}

export default customGroup
